import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateBookingPassCommand,
  FilterBookingPassesCommand,
  ValidateBookingPassInBuildingCommand,
} from './booking-pass.commands';
import {
  CreatedBookingPassEvent,
  FilteredBookingPassesDomainEvent,
  UpdatedBookingPassDomainEvent,
} from './booking-pass.events';

@Injectable()
export class BookingPassEffects {
  prefix = 'booking-pass';
  createBookingPassCommand: Observable<Action<string>> & CreateEffectMetadata;
  filterBookingPassesCommand: Observable<Action<string>> & CreateEffectMetadata;
  validateBookingPassInBuildingCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createBookingPassCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateBookingPassCommand,
      CreatedBookingPassEvent,
      this.prefix,
    );

    this.filterBookingPassesCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: FilterBookingPassesCommand,
      prefix: this.prefix,

      others: (httpResponse: any, commandData: any) => {
        const data = httpResponse.data;
        return [
          FilteredBookingPassesDomainEvent({
            data: data,
            transactionId: commandData.transactionId,
          }),
        ];
      },
    });
    this.validateBookingPassInBuildingCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: ValidateBookingPassInBuildingCommand,
      prefix: this.prefix,
    });
  }
}
